<template>
  <div>
    <div
      @click="backToTeam"
      class="flex items-center gap-2 m-3 cursor-pointer rounded-full w-max p-2 justify-center text-sm bg-white"
    >
      <img class="h-4 object-contain" src="@/assets/icons/left.png" />
      <p>Back to your team</p>
    </div>
    <div class="bg-white m-3 rounded-md">
      <div class="flex flex-wrap justify-between gap-4 p-4">
        <div class="flex gap-5 items-center w-44">
          <div class="h-8 w-8 rounded-full">
            <img
              class="h-full w-full rounded-full"
              src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
            />
          </div>
          <p>John Doe</p>
        </div>
        <div
          v-for="(stat, index) in stats"
          :key="index"
          class="flex justify-between lg:w-max w-full gap-3 items-center border-1.5 p-2 rounded"
        >
          <p class="text-sm">{{ stat.name }}</p>
          <p class="text-green-500 font-bold text-sm">{{ stat.value }}</p>
        </div>
      </div>
    </div>
    <div class="bg-white m-3 rounded-md">
      <div class="p-3">
        <ve-table :columns="columns" :table-data="tableData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamMemberTimeAndAttendance",
  data() {
    return {
      stats: [
        {
          name: "Work Schedule",
          value: "15 Hrs",
        },
        {
          name: "Logged Hours",
          value: "20 Hrs",
        },
        {
          name: "Paid Time",
          value: "50 Hrs",
        },
        {
          name: "Deficit",
          value: "15 Hrs",
        },
        {
          name: "Overtime",
          value: "10 Hrs",
        },
      ],
      columns: [
        { field: "Date", key: "a", title: "Date" },
        { field: "ClockIn", key: "b", title: "Clock In" },
        { field: "ClockInLocation", key: "c", title: "Clock In Location" },
        {
          field: "ClockOutLocation",
          key: "x",
          title: "Clock Out Location",
        },
        { field: "WorkSchedule", key: "d", title: "Work Schedule" },

        {
          field: "LoggedIn",
          key: "f",
          title: "Logged In",
        },
        {
          field: "Overtime",
          key: "g",
          title: "Overtime",
        },
        {
          field: "Deficit",
          key: "h",
          title: "Deficit",
        },
        {
          field: "Action",
          key: "ff",
          title: "Action",
          renderBodyCell: () => {
            return (
              <p class="cursor-pointer transform rotate-90 font-bold">
                &#8230;
              </p>
            );
          },
        },
      ],

      tableData: [
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
        {
          Date: "2020-01-01",
          ClockIn: "10:00 AM",
          ClockInLocation: "Kenya",
          ClockOutLocation: "Kenya",
          WorkSchedule: "50 Hrs",
          LoggedIn: "08 Hrs",
          Overtime: "08 Hrs",
          Deficit: "03 Hrs",
          Action: "",
        },
      ],
    };
  },
  methods: {
    backToTeam() {
      this.$emit("backToTeam");
    },
  },
};
</script>
